import React from "react";

interface Props {
     isBusy: boolean
}

export class SpinnerComponent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

    }

    generateHtml = () => {
        return (<>
            <div className='ontario-loading-indicator__overlay' aria-hidden='false' role='alert' aria-live='assertive'>
                <div className='ontario-loading-indicator'>
                    <svg className='ontario-loading-indicator__spinner' viewBox="25 25 50 50" xmlns='http://www.w3.org/2000/svg'>
                        <circle cx="50" cy="50" r="20" fill="none" strokeWidth="4" />
                    </svg>
                    <p>Loading</p>
                </div>
            </div>
        </>)
    }

    render() {
        return this.props.isBusy && this.generateHtml();
    }

}